// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_XDv","cls2":"AuthorPopover-cls2_J7a AuthorPopover-cls1_XDv"};